import { crmClient } from './crm-client';
import type { Lead, CreateLeadRequest, LeadCaptureData } from '@/types';
import type { ProductConfig } from '@/types/product';

export class LeadService {
  private static instance: LeadService;

  private constructor() {}

  static getInstance(): LeadService {
    if (!LeadService.instance) {
      LeadService.instance = new LeadService();
    }
    return LeadService.instance;
  }

  async getLeadById(oportunidadeId: number, funilId: number): Promise<Lead | null> {
    try {
      const lead = await crmClient.get<Lead>(
        `/Oportunidade?funilId=${funilId}&oportunidadeId=${oportunidadeId}`
      );
      return lead;
    } catch (error) {
      console.error('Error fetching lead:', error);
      return null;
    }
  }

  async createLead(data: LeadCaptureData, config: ProductConfig): Promise<Lead> {
    const request: CreateLeadRequest = {
      funilId: config.funilId,
      nome: data.nome,
      telefone: this.formatPhoneForCRM(data.telefone),
      origem: config.crmOrigem,
      campanha: 'Diagnostico',
      cidade: data.cidade,
      email: data.email,
      obs: 'Capital disponível para investir',
      faturamentoPotencial: 0
    };

    const response = await crmClient.post<{ id: number }>(
      '/Oportunidade',
      request,
      true
    );

    if (!response.id) {
      throw new Error('CRM did not return a valid lead ID');
    }

    console.log(`Lead created with ID: ${response.id}`);

    return {
      id: response.id,
      nome: data.nome,
      email: data.email,
      telefone: data.telefone,
      cidade: data.cidade,
      origem: request.origem,
      campanha: request.campanha,
      funilId: request.funilId
    };
  }

  private formatPhoneForCRM(phone: string): string {
    const cleaned = phone.replace(/\D/g, '');
    if (cleaned.startsWith('55')) {
      return cleaned;
    }
    return `55${cleaned}`;
  }
}

export const leadService = LeadService.getInstance();
